module.exports = __webpack_public_path__ + "static/media/nb.b884cec9.svg";